const padNumber = (value) => String(value).padStart(2, "0");

export const parseDateString = (dateString) => {
  if (!dateString || typeof dateString !== "string") return null;

  const [year, month, day] = dateString.split("-").map(Number);

  if (!year || !month || !day) return null;

  return new Date(year, month - 1, day);
};

export const formatDateForApi = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  return [
    date.getFullYear(),
    padNumber(date.getMonth() + 1),
    padNumber(date.getDate()),
  ].join("-");
};

export const formatDateForDisplay = (dateInput) => {
  const date =
    dateInput instanceof Date ? dateInput : parseDateString(dateInput);

  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";

  return [
    padNumber(date.getDate()),
    padNumber(date.getMonth() + 1),
    date.getFullYear(),
  ].join("-");
};

export const formatDateRangeLabel = (startDate, endDate) => {
  const formattedStart = formatDateForDisplay(startDate);
  const formattedEnd = formatDateForDisplay(endDate);

  if (formattedStart && formattedEnd) {
    return formattedStart === formattedEnd
      ? formattedStart
      : `${formattedStart} to ${formattedEnd}`;
  }

  return formattedStart || formattedEnd || "";
};

export const getPresetDateRange = (value, baseDate = new Date()) => {
  const today = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());

  switch (value) {
    case "today":
      return {
        startDate: formatDateForApi(today),
        endDate: formatDateForApi(today),
      };

    case "last7Days": {
      const start = new Date(today);
      start.setDate(today.getDate() - 6);

      return {
        startDate: formatDateForApi(start),
        endDate: formatDateForApi(today),
      };
    }

    case "thisMonth": {
      const start = new Date(today.getFullYear(), today.getMonth(), 1);

      return {
        startDate: formatDateForApi(start),
        endDate: formatDateForApi(today),
      };
    }

    case "last6Months": {
      const start = new Date(today);
      start.setMonth(today.getMonth() - 6);

      return {
        startDate: formatDateForApi(start),
        endDate: formatDateForApi(today),
      };
    }

    case "thisQuarter": {
      const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
      const start = new Date(today.getFullYear(), quarterStartMonth, 1);

      return {
        startDate: formatDateForApi(start),
        endDate: formatDateForApi(today),
      };
    }

    default:
      return null;
  }
};

export const getMatchingDatePreset = (
  { startDate, endDate } = {},
  baseDate = new Date()
) => {
  const presetValues = [
    "today",
    "last7Days",
    "thisMonth",
    "last6Months",
    "thisQuarter",
  ];

  return (
    presetValues.find((preset) => {
      const range = getPresetDateRange(preset, baseDate);

      return (
        range?.startDate === startDate &&
        range?.endDate === endDate
      );
    }) || ""
  );
};
